import axios from 'axios';

import { GLOBAL_VARS } from "../config/global-vars.config";
import { Colegio } from './colegios.service';
import { Curso } from './cursos.service';

export interface Estudiante {
  id: string;
  colegio?: Colegio;
  curso?: Curso;
  email?: string;
  nombres: string;
  apellidos: string;
  creado?: string;
  activo?: number;
  btnDelete?: number;
};

// Configuración de Axios
axios.defaults.baseURL = GLOBAL_VARS.API;

axios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  config.headers['Authorization'] = token;

  return config;
});

class EstudiantesService {
  static async listar() {
    try {
      const response = await axios.get<Estudiante[]>(`/estudiantes`);

      return response.data;
    } catch (e) {
      console.error(e);
      return [];
    }
  };

  static async crear(estudiante: Estudiante) {
    try {
      const response = await axios.post(`/estudiantes`, estudiante, { headers: {} });

      if (response.status === 201) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
    }
  }

  static async cargar(file: File | null) {
    try {
      if (!file) {
        console.error("No file provided for upload");
        return false;
      }

      const data = new FormData();
      data.append('file', file);

      const response = await axios.post(`/estudiantes/load`, data, { headers: {} });

      if (response.status === 201) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
    }
  }

  static async descargar() {
    try {
      const response = await axios.get(`/estudiantes/download-file`, {
        responseType: 'blob', // Esto indica que esperas una respuesta binaria (archivo)
      });

      return response;
    } catch (e) {
      console.error(e)
    }
  }

  static async eliminar(id: string) {
    try {
      const response = await axios.delete(`/estudiantes/${id}`);

      if (response.status === 204) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e);
    }
  }

  static async actualizar(estudiante: Estudiante) {
    try {
      const response = await axios.patch(`/estudiantes/${estudiante.id}`, estudiante, { headers: {} });

      if (response.status === 201) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export default EstudiantesService;
